import { useForm, FormProvider } from 'react-hook-form';
import { readErrors, wrapArray } from '../utils';
import axios from "axios";
import { useHistory } from 'react-router-dom';
import { useState } from 'react';

/**
 * @param {Object} props 
 * @param {(data: Object, form: ReturnType<useForm>) => Promise | void} props.onSubmit
 * @param {(response?: Object, form: ReturnType<useForm>, data: Object) => Promise | void} props.onSuccess
 * @param {ReturnType<useForm>} props.hook
 * @param {Parameters<useForm>[0]} props.options
 * @param {string} props.success
 * @param {string} props.post
 * @param {string} props.redirect
 * @param {boolean | string | string[]} props.resetOnSuccess
 * @param {boolean} props.disableOnSuccess
 * @param {boolean} props.noAnimation
 * @param {boolean} props.noAsterisk
 * @param {string} props.className
 */
export default function ControlledForm({ onSubmit, onSuccess, hook, options = {}, success, post, redirect, resetOnSuccess, disableOnSuccess, noAnimation, noAsterisk, children, ...rest }) {
    const [formDisabled, setFormDisabled] = useState(false);

    if (formDisabled) {
        options.disabled = true;
    }

    const formHook = hook ?? useForm(options);
    const history = useHistory();

    async function onFormSubmit(data) {
        try {
            if (await onSubmit?.(data, formHook) === false) {
                return;
            }

            let response;
            if (post) {
                response = await axios.post(post, data);
            }

            if (success) {
                formHook.setError("root.formResponse", { type: "success", message: success });
            }

            await onSuccess?.(response?.data, formHook, data);

            if (redirect) {
                history.push(redirect);
            }

            if (resetOnSuccess === true) {
                formHook.reset(undefined, { keepErrors: true });
            } else if (typeof resetOnSuccess === "string" || Array.isArray(resetOnSuccess)) {
                wrapArray(resetOnSuccess).forEach(f => formHook.resetField(f));
            }

            if (disableOnSuccess) {
                setFormDisabled(true);
            }
        } catch (error) {
            formHook.setError("root.formResponse", { type: "error", message: readErrors(error) });
        }
    }

    formHook.custom = { noAnimation, noAsterisk };

    return (
        <FormProvider {...formHook}>
            <form {...rest} onSubmit={formHook.handleSubmit(onFormSubmit)} noValidate>
                {children}
            </form>
        </FormProvider >
    );
}